import "./ReadArticleComponent.scss";
import MediaViewComponent from "./shared/MediaViewComponent";
import FieldPairComponent from "./shared/FieldPairComponent";

const ReadArticleComponent = ({ data }) => {
  return (
    <MediaViewComponent data={data}>
      <FieldPairComponent label="Content">
        <div className="rich-text">
          <p
            className="field-value"
            dangerouslySetInnerHTML={{ __html: data?.content }}
          ></p>
        </div>
      </FieldPairComponent>
    </MediaViewComponent>
  );
};

export default ReadArticleComponent;
